var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContractsFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3677_1835",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3677_1835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4987 17.4993C2.04036 17.4993 1.648 17.3362 1.32161 17.0098C0.995226 16.6834 0.832031 16.291 0.832031 15.8327V5.83268C0.832031 5.59657 0.911892 5.39865 1.07161 5.23893C1.23134 5.07921 1.42925 4.99935 1.66536 4.99935C1.90148 4.99935 2.09939 5.07921 2.25911 5.23893C2.41884 5.39865 2.4987 5.59657 2.4987 5.83268V15.8327H15.832C16.0681 15.8327 16.2661 15.9125 16.4258 16.0723C16.5855 16.232 16.6654 16.4299 16.6654 16.666C16.6654 16.9021 16.5855 17.1 16.4258 17.2598C16.2661 17.4195 16.0681 17.4993 15.832 17.4993H2.4987ZM5.83203 14.166C5.3737 14.166 4.98134 14.0028 4.65495 13.6764C4.32856 13.35 4.16536 12.9577 4.16536 12.4993V3.33268C4.16536 2.87435 4.32856 2.48199 4.65495 2.1556C4.98134 1.82921 5.3737 1.66602 5.83203 1.66602H9.3112C9.53342 1.66602 9.74523 1.70768 9.94662 1.79102C10.148 1.87435 10.3251 1.9924 10.4779 2.14518L11.6654 3.33268H17.4987C17.957 3.33268 18.3494 3.49588 18.6758 3.82227C19.0022 4.14865 19.1654 4.54102 19.1654 4.99935V12.4993C19.1654 12.9577 19.0022 13.35 18.6758 13.6764C18.3494 14.0028 17.957 14.166 17.4987 14.166H5.83203Z",
    fill: "#F5F4F3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractsFilled);
export default __webpack_public_path__ + "static/media/contracts-filled.c316b25dc84795ab02b5f912284e5983.svg";
export { ForwardRef as ReactComponent };